/* eslint-disable react/prop-types */
import classes from "./card-view-service.module.scss";
import Label from "@/components-library/widgets/label";
import Button from "@/components-library/widgets/button";
import Flex from "@/components-library/layout/flex";
import Spacer from "@/components-library/widgets/spacer";

import classNames from "classnames";
function CardViewService({ onLoad, title, content, image, button, onClick }) {
  if (title && content) {
    return (
      <Flex
        align="center"
        direction="column"
        justify="center"
        className={classNames(classes.container)}
      >
        <img src={image} alt="Logo" className={classes.image} onLoad={onLoad} />

        <Flex
          align="center"
          direction="column"
          justify="space-between"
          className={classes.subContainer}
        >
          <Label
            weight="bold"
            tag="h4"
            color="primary"
            align="center"
            className={classes.title}
          >
            {title}
          </Label>
          <Flex
            align="flex-start"
            direction="column"
            justify="flex-start"
            className={classes.contentContainer}
          >
            <Label
              align="center"
              size="md"
              color="secondary"
              className={classes.content}
            >
              {content}
            </Label>
            <Spacer />
          </Flex>
          <Button
            onClick={onClick}
            size="sm"
            color="primary"
            className={classes.button}
          >
            {button.title}
          </Button>
        </Flex>
      </Flex>
    );
  } else {
    return <></>;
  }
}

export default CardViewService;
